import type { MantineTheme } from "@mantine/core";

// TODO: update with sm width check
export const handleSpacing = (theme: MantineTheme, spacing: string) => spacing;
